import * as React from 'react';
import { Button, Modal, Toast, ToastContainer } from 'react-bootstrap';
import { connect, MapDispatchToProps } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { hideNotificationPopup } from '../../actions/notificationActions';
import { Notification, NotificationType } from '../../models/notification';
import { AppState } from '../../models/state/appState';

interface StateToProps {
  notifications: Notification[];
}

interface DispatchToProps {
  actions: {
    hideNotificationPopup: (uid: number) => void;
  };
}

type NotificationManagerProps = StateToProps & DispatchToProps;

const toastVariants: { [key in NotificationType]: string } = {
  info: 'info',
  success: 'success',
  error: 'danger',
  warning: 'warning'
};

export const NotificationManager = (props: NotificationManagerProps) => {
  const visible = props.notifications.filter((notification) => !notification.hidden);
  // errors interrupt rather than autohide: a toast that vanishes after 5s loses the reason the action failed
  const error = visible.find((notification) => notification.type === 'error');

  return (
    <>
      <Modal
        aria-labelledby="notification-error-title"
        centered
        show={!!error}
        onHide={() => error && props.actions.hideNotificationPopup(error.uid)}
      >
        <Modal.Header closeButton>
          <Modal.Title id="notification-error-title">{error?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0">{error?.detail}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => error && props.actions.hideNotificationPopup(error.uid)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer position="top-end" className="p-3 position-fixed">
        {visible
          .filter((notification) => notification.type !== 'error')
          .map((notification) => (
            <Toast
              key={notification.uid}
              bg={toastVariants[notification.type]}
              autohide
              delay={5000}
              onClose={() => props.actions.hideNotificationPopup(notification.uid)}
            >
              <Toast.Header>
                <strong className="me-auto">{notification.title}</strong>
              </Toast.Header>
              {notification.detail && <Toast.Body className="text-white">{notification.detail}</Toast.Body>}
            </Toast>
          ))}
      </ToastContainer>
    </>
  );
};

const mapStateToProps = (state: AppState): StateToProps => {
  return {
    notifications: state.notifications.notifications
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchToProps, any> = (dispatch) => ({
  actions: bindActionCreators({ hideNotificationPopup }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationManager);
